import {connect} from "react-redux";
import PartnersModal from "../../components/Modals/PartnersModal/PartnersModal";
import {getSociete, setSociete} from "../../actions/user";

const MapStateToProps = (state) => ({
    societe: state.user.societe,
    dataUser: state.user.dataUser
});

const MapDispatchToProps = (dispatch) => ({
    getSociete: (data) => {
        dispatch(getSociete(data));
    },
    setSociete: (data) => {
        dispatch(setSociete(data));
    },
});

export default connect(MapStateToProps, MapDispatchToProps)(PartnersModal);